import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "App";
import axiosInstance from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";

export const useRodoAccept = (
  options?: UseMutationOptions<any, Error, string>
) => {
  return useMutation({
    mutationKey: ["rodo-acceptance"],
    mutationFn: async (uuid: string) => {
      return axiosInstance
        .post(`users/rodo-acceptance/${uuid}`)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Przetwarzanie akceptacji RODO...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "rodo-acceptance",
      });

      if (options?.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "RODO zostało zaakceptowane",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "rodo-acceptance",
      });

      queryClient.invalidateQueries({ queryKey: ["users"] });

      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Wystąpił błąd podczas akceptacji RODO",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "rodo-acceptance",
      });

      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
